export const filter = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    filterName: { en: 'Filter name', ko: '필터 이름', fr: '' },
    regExp: { en: 'Regular expression', ko: '정규식', fr: '' },
    registerDate: { en: 'Register date', ko: '등록날짜', fr: '' },
  },
  info: {
    filterName: { en: 'Filter name', ko: '필터 이름', fr: '' },
    regExp: { en: 'Regular expression', ko: '정규식', fr: '' },
    registerDate: { en: 'Register date', ko: '등록날짜', fr: '' },
  },
};
